import cx from 'classnames';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { anowVendorApiRequest } from '../../../../../../shared/libs/anowApiRequest';
import { removePaymentCard } from '../../../../../actions/formConfigActions';
import PaymentMethod from '../PaymentMethod/PaymentMethod';
import getCardBrand from './getCardBrand';

import './CardsList.scss';

const CardsList = ({
  value, onChange, paymentOptions, setShowAddCard,
}) => {
  const dispatch = useDispatch();
  const onRadioChange = useCallback((e) => {
    const {
      target: { value: paymentMethodId, checked },
    } = e;
    if (!checked) {
      onChange('');
    } else {
      onChange(paymentMethodId);
    }
  }, []);
  return (
    <div className="row">
      <div className="col-12">
        <h4>Choose a payment method</h4>
        <p>You will not be charged until the order is processed</p>
      </div>
      <div className="col-12">
        <ul className="list-group">
          {paymentOptions.map(
            ({
              brand,
              paymentMethodId,
              last4,
              expireMonth,
              expireYear,
              metadata,
            }) => (
              <li
                key={paymentMethodId}
                className={cx(
                  'list-group-item',
                  'd-flex',
                  'justify-content-between',
                  'cards-list__row',
                  {
                    'cards-list__row-active': paymentMethodId === value,
                  },
                )}
              >
                <div className="form-check w-100">
                  <input
                    className="form-check-input h-100 mt-0"
                    type="checkbox"
                    name="payment"
                    value={paymentMethodId}
                    id={paymentMethodId}
                    checked={paymentMethodId === value}
                    onChange={onRadioChange}
                  />
                  <label
                    className={cx('form-check-label', 'w-100', {
                      'form-check-label-active': paymentMethodId === value,
                    })}
                    htmlFor={paymentMethodId}
                  >
                    <div className="d-flex align-items-center">
                      <span className="ml-2 mr-3">
                        <PaymentMethod brand={brand} />
                      </span>
                      <div>
                        <div className="mb-2">
                          {`${getCardBrand(brand)} ending in ${last4}`}
                        </div>
                        <div>
                          <small className="mr-2">
                            {`EXP: ${expireMonth}/${expireYear}`}
                          </small>
                          <span
                            className={cx('badge', 'badge-secondary', {
                              'badge-active': paymentMethodId === value,
                            })}
                          >
                            {metadata.sitesName}
                          </span>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
                <div className="d-flex flex-column">
                  <div
                    className={cx({
                      'd-none': paymentMethodId === value,
                    })}
                  >
                    <button
                      type="button"
                      className="btn btn-outline-dark cards-list__delete-btn"
                      disabled={paymentMethodId === value}
                      onClick={() => {
                        if (
                          window.confirm(
                            `Are you sure you want to delete card ${getCardBrand(
                              brand,
                            )} ending in ${last4}`,
                          )
                        ) {
                          dispatch(removePaymentCard(paymentMethodId));
                          anowVendorApiRequest(
                            {
                              url: `customer/settings/preauth/?paymentMethodId=${paymentMethodId}`,
                            },
                            'delete',
                          );
                        }
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </li>
            ),
          )}
          <li className="list-group-item p-0">
            <button
              type="button"
              className="btn btn-block text-left p-3 cards-list__add-new"
              onClick={() => {
                setShowAddCard(true);
              }}
            >
              + Add a new credit card
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

CardsList.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  setShowAddCard: PropTypes.func.isRequired,
  paymentOptions: PropTypes.arrayOf(
    PropTypes.shape({
      paymentCustomerId: PropTypes.string,
      paymentMethodId: PropTypes.string,
      brand: PropTypes.string,
      last4: PropTypes.string,
      expireMonth: PropTypes.number,
      expireYear: PropTypes.number,
    }),
  ),
};
CardsList.defaultProps = {
  paymentOptions: [],
};

export default CardsList;
